<template>
  <form class="Keywords" @click="broadcast('close-menus')">
    <label><h4>Keywords </h4></label>
    <KeywordSearchField />
  </form>
</template>

<script>
import KeywordSearchField from '@/components/KeywordSearchField'
export default {
  name: 'Keywords',
  components: { KeywordSearchField }
};
</script>

<style scoped lang="scss">
.Keywords {
  width: 50%;
  float: left;
  padding: 30px 0;
  padding-left: 30px;
  @include smx { width: 100%; float: none; padding-left: 15px;}

  h4 {
    font-weight: bold;
    font-size: 24px;
    display: inline-block;
    margin-right: 4px;
    width: 100px;
  }
}
</style>
